import { render } from "./ConnectCommitters.vue?vue&type=template&id=a9a11fe2"
import script from "./ConnectCommitters.vue?vue&type=script&lang=js"
export * from "./ConnectCommitters.vue?vue&type=script&lang=js"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__